import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const BookIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 17.75C4.25736 17.75 3.25 16.7426 3.25 15.5V4.5C3.25 3.25736 4.25736 2.25 5.5 2.25H14.5C15.1904 2.25 15.75 2.80964 15.75 3.5V5.275C16.3206 5.39082 16.75 5.89526 16.75 6.5V16.5C16.75 17.1904 16.1904 17.75 15.5 17.75H5.5ZM5.5 3.75C5.08579 3.75 4.75 4.08579 4.75 4.5C4.75 4.91421 5.08579 5.25 5.5 5.25H14.25V3.75H5.5ZM5.5 6.75H15H15.25V16.25H5.5C5.08579 16.25 4.75 15.9142 4.75 15.5V6.62197C4.98458 6.70488 5.23702 6.75 5.5 6.75ZM6.5 8H10.5C10.7761 8 11 8.22386 11 8.5V10.5C11 10.7761 10.7761 11 10.5 11H6.5C6.22386 11 6 10.7761 6 10.5V8.5C6 8.22386 6.22386 8 6.5 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 4.50156C4.75 4.91679 5.0868 5.25313 5.5 5.25313H14.25V3.75H5.5C5.0868 3.75 4.75 4.08633 4.75 4.50156Z"
        fill="currentColor"
        fillOpacity="0.12"
      />
    </SvgIcon>
  );
};
